import styled from 'styled-components';
import { light, dark } from '@mlb/play-ui';
import { Themes } from '@mlb/play-ui';
import { translate } from '../../configs';

export interface SponsorshipTagProps {
  className?: string;
  imgURL?: string;
  altText?: string;
  tagText?: string;
  textTheme?: Themes;
}

const defaultText = `${translate('presented')} ${translate('by')}`;

const StyledSponsorshipTag = styled.div<{ textTheme: Themes }>`
  display: inline-flex;

  p {
    color: ${({ textTheme }) =>
      textTheme === Themes.LIGHT ? light.fontColor : dark.fontColor};
    text-transform: uppercase;
    font-size: 8px;
    white-space: nowrap;
  }

  img {
    margin-left: 5px;
    height: 14px;
    align-self: center;
  }
`;

export const SponsorshipTag = ({
  className,
  imgURL,
  altText,
  textTheme = Themes.LIGHT,
  tagText = defaultText,
}: SponsorshipTagProps) =>
  imgURL &&
  altText && (
    <StyledSponsorshipTag
      className={className}
      textTheme={textTheme}
      role="note"
      aria-label={`${tagText} ${altText}`}
    >
      <p aria-hidden={true}>{tagText}</p>
      <img src={imgURL} alt={altText} />
    </StyledSponsorshipTag>
  );

export default SponsorshipTag;
